import { useSearch, useLocation } from "wouter";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from "react-hot-toast";
import { useEffect } from "react";
import { Button } from "./Button";


const AuthorizationCodeRedirect = () => {
    const searchString = useSearch();
    const [, setLocation] = useLocation();

    // Extract code and state from URL parameters
    const urlParams = new URLSearchParams(searchString);
    const code = urlParams.get("code");
    const state = urlParams.get("state"); // This contains the redirect destination

    useEffect(() => {
        if (code && state) {
            // Process the authorization code and redirect to the intended destination
            const redirectTo = `/${state}`;

            // Show success message and redirect
            toast.success("Authenticatie succesvol! Je wordt doorgestuurd...");

            // Redirect after a short delay to show the toast
            setTimeout(() => {
                setLocation(redirectTo);
            }, 1500);
        }
    }, [code, state, setLocation]);

    return (
        <div>
            <p className="text-xl font-bold mb-3">
                Authenticatie succesvol!</p>
            {code && state ? (
                <p>Je wordt doorgestuurd naar je oorspronkelijke pagina...</p>
            ) : (
                <>
                    <p className="text-xl font-bold mb-3">Je autorisatie code</p>
                    <p>{code}</p>
                    <CopyToClipboard text={code || ""} onCopy={() => toast.success('Code gekopieerd!')}>
                        <Button color="primary" className="mt-3">
                            Kopieer code
                        </Button>
                    </CopyToClipboard>
                </>
            )}
        </div>
    )

}

export default AuthorizationCodeRedirect
